import React, { Component } from 'react';
import { withStyles, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
// import DialogActions from '@material-ui/core/DialogActions';
// import DialogTitle from '@material-ui/core/DialogTitle';

// import Grid from '@material-ui/core/Grid';
// import VideoPlayer from '../../components/VideoPlayer';

const styles = (theme) => ({
  dialogRoot: {},
  dialogTitle: {
    margin: '0',
    padding: '8px 8px 0',
  },
  dialogTitleContent: {
    textAlign: 'center',
    fontSize: '19.5px',
    fontWeight: 'bold',
    color: '#377ac6',
    margin: '0 15px',
    paddingTop: '1em',
    paddingBottom: '1.5em',
    borderBottom: '2px solid #377ac6',
  },
  closeBtn: {
    right: '12px',
    top: '4px',
    color: '#ffffff',
    [theme.breakpoints.down('sm')]: {
      right: 0,
      top: 0,
    },
    '& svg': {
      fontSize: '1.5em',
      [theme.breakpoints.down('sm')]: {
        fontSize: '1.2em',
      },
    },
  },
  dialogContent: {
    // marginBottom: '10px',
    overflow: 'hidden',
    '& .jw-controlbar': {
      bottom: '5%',
    },
    '& .jw-icon-fullscreen': {
      display: 'none',
    },
  },
  dialogActions: {
    display: 'none',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  contents: {
    padding: theme.spacing(1),
  },
  msgImg: {
    width: '100%',
    height: 'auto',
  },
  vodIframe: {
    height: '40vw',
    [theme.breakpoints.down('lg')]: {
      height: '33vw', //19
    },
    [theme.breakpoints.down('md')]: {
      height: '50vw', //26
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: '-4%',
      marginBottom: '-5%',
    },
  },
});

class WelcomeMsg extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { classes, open, onClose } = this.props;
    return (
      <div>
        <Dialog
          fullWidth={true}
          // maxWidth={'md'}
          onClose={onClose}
          aria-labelledby="welcome-msg-dialog"
          open={open}
          // disableBackdropClick={disableBackdrop}
          // disableEscapeKeyDown={disableBackdrop}
          className={classes.dialogRoot}
        >
          {/* <DialogTitle className={classes.dialogTitle}>
            <div className={classes.dialogTitleContent}>
              <span>Welcome Message</span>
            </div>
          </DialogTitle> */}
          <DialogContent className={classes.dialogContent} style={{ padding: 0, margin: 0 }}>
            <IconButton onClick={onClose} className={classes.closeBtn} style={{ position: 'absolute', zIndex: 999 }}>
              <CloseIcon />
            </IconButton>
            <div>
              {/* <VideoPlayer
                src={'https://player.vimeo.com/external/497475697.sd.mp4?s=255368e3c22b2c07bb0a4494efa4fcf15d8cb9f3&profile_id=165'}
                type={'welcomemsg'}
              /> */}
              <iframe
                id="player"
                title="welcome_msg"
                type="text/html"
                width="800"
                src={`https://player.vimeo.com/video/497475697`}
                frameBorder="0"
                allow="accelerometer; autoplay; encrypted-media;"
                style={{ width: '100%' }}
                className={classes.vodIframe}
              ></iframe>
            </div>
          </DialogContent>
          {/* <DialogActions className={classes.dialogActions}>
            <div style={{ borderTop: '1px solid rgba(1,1,1,0.2)', margin: '0 15px', paddingTop: '10px' }}>
              <Button onClick={onClose} style={{ color: '#000000', fontSize: '18px', fontWeight: '600' }}>
                닫기
              </Button>
            </div>
          </DialogActions> */}
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(WelcomeMsg);
